import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import type { AxiosErrorResponse, BaseReportsPaginated, BaseReportsPaginatedResponse, PaginatedData } from '@/types';

export type ListAllStrainIndexDTO = BaseReportsPaginated;

export type ListAllStrainIndexResponse = PaginatedData<BaseReportsPaginatedResponse>;

async function listStrainIndexPaginated(params: ListAllStrainIndexDTO): Promise<ListAllStrainIndexResponse> {
	const url = '/ergonomic-tool/strain-index/reports/list-all';
	const { data } = await Api.get<ListAllStrainIndexResponse>(url, {
		params
	});
	return data;
}

export const useListStrainIndexPaginated = ({
	limit,
	offset,
	sector_id,
	company_id,
	cellule_id,
	report_name,
	activity_id,
	evaluator_id,
	original_name,
	created_at_end,
	workstation_id,
	organization_id,
	created_at_start,
	isSelectedReport
}: ListAllStrainIndexDTO) => {
	const enabled = !!limit && !!isSelectedReport && offset >= 0;
	const strainIndexReport = useQuery<ListAllStrainIndexResponse, AxiosErrorResponse>(
		[
			QUERY_KEYS.GET_STRAIN_INDEX_REPORTS_PAGINATED,
			[
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			]
		],
		() =>
			listStrainIndexPaginated({
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			}),
		{
			enabled,
			retry: 0
		}
	);
	return strainIndexReport;
};
